var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncliClassique(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_843_1923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7594 17.3389C31.8618 16.9879 32.8122 16.2422 33.3386 16.4615C35.2103 16.9295 34.8301 25.3811 34.6985 27.2235C34.4207 31.1277 33.4994 33.7743 29.5514 35.2365C26.9633 36.187 14.008 36.1139 10.7472 35.7922C7.28174 35.4559 3.94787 33.2918 3.33373 29.6801C3.07053 28.1155 3.04129 17.6606 3.69929 16.9002C4.31342 16.1837 5.45396 16.3153 5.89263 17.2658C7.63268 21.0237 3.49458 31.1715 9.15339 32.6338C11.7562 33.3064 24.4629 33.204 27.4897 32.8385C28.2062 32.7507 29.1274 32.546 29.7269 32.1658C30.1948 31.8734 31.7302 29.797 31.7302 29.4169V17.3681L31.7594 17.3389Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5125 0.0591483C21.0129 -0.569609 24.8731 4.02178 25.7359 4.02178C29.0259 6.5 26.3939 1.02422 29.0259 1.05346C32.2428 1.09733 30.8975 6.36134 31.5848 8.01366C32.1843 9.46126 38.6327 12.5904 37.8138 14.2281C37.4629 14.9446 36.5563 15.1639 35.8983 14.6814L19.1558 2.92511L2.28176 14.5352C1.03886 15.6026 -0.715806 14.2427 0.307752 12.9267C5.05999 9.69522 9.70986 5.76183 14.4621 2.61804C15.164 2.15013 18.0153 0.190749 18.5125 0.0737706V0.0591483Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_1923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.8863,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncliClassique);
export default __webpack_public_path__ + "static/media/incli_classique.59990b1d20e7dc1315bd3ff8c229fef9.svg";
export { ForwardRef as ReactComponent };